module.exports = __webpack_public_path__ + "static/img/zijian4.e0784685.png";